import styled from "styled-components";
import { Radius, Spacing } from "components/designV2/constants";
import { TypographyV2 } from "config/font";
import { ColorV2 } from "config/colors";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FocusSentinel = styled.div`
  width: 0;
  height: 0;
  overflow: hidden;
  outline: none;
`;

export const DateContext = styled.div`
  align-items: center;
  background: ${ColorV2.Blue7};
  border-radius: ${Radius.md}px;
  display: flex;
  gap: ${Spacing.sm}px;
  padding: ${Spacing.md}px;
`;

export const DateText = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const TimeRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const TimeSeparator = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  margin-bottom: 8px;
`;

export const BreakRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const BreakSuffix = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  margin-bottom: 8px;
`;
